import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {store} from './services/store'
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    //! Comment out strict mode to avoid double API calls
    
  // <React.StrictMode>
    <Provider store={store}>
      <App />
      </Provider>
//  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
